'use client';

import { useCallback } from 'react';
import { useServiceConsentGranted } from '@/features/consent';
import { MATOMO_SERVICE_ID } from './MatomoTagManager';
import { trackFormSubmit } from './matomo-events';

/**
 * Reports a form submission as a Matomo event. Call it only once the server has
 * confirmed the submission — rejections by validation, spam guard or captcha must
 * not count. Without Matomo consent it does nothing.
 */
export function useFormSubmitTracking(): (apartmentNumber: string | null) => void {
    const granted = useServiceConsentGranted(MATOMO_SERVICE_ID);

    return useCallback(
        (apartmentNumber: string | null) => {
            if (granted) trackFormSubmit(apartmentNumber);
        },
        [granted],
    );
}
